import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';

class MenuItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <li className="menu-item">
        <Link to={this.props.route}
          className={location.pathname === this.props.route ? 'nav-item selected__selected' : 'nav-item'} onlyActiveOnIndex>
          <i className={this.props.icon} style={{marginRight: '4px', color: '#4F4F4F'}}/>
          <span className="title" style={{marginLeft: '10px', color: '#CCCCCC'}}>{this.props.title}</span>
        </Link>
      </li>
    );
  }
}


MenuItem.propTypes = {
  route: PropTypes.string,
  isIndex: PropTypes.bool,
  icon: PropTypes.string,
  title: PropTypes.string,
  right: PropTypes.string,
};

MenuItem.defaultProps = {};

export default MenuItem;
